import React, { useEffect, useRef, useState } from "react";
import bgImage from "./Image/widgets_bg.png";
import barTitleImg from "./Image/bar_titles_f.png";
import logoImg from "./Image/scrolled_logo_lrg.png";
import r1Img from "./Image/registration_board_01.png";
import r2Img from "./Image/registration_board_02.png";
import r3Img from "./Image/registration_board_03.png";
import r4Img from "./Image/registration_board_04.png";

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK ?? "";

const GRADE_OPTIONS = [
	{ value: "", label: "Grade", disabled: true },
	{ value: "0", label: "Kindergarten", disabled: false },
	{ value: "1", label: "Grade 1", disabled: false },
	{ value: "2", label: "Grade 2", disabled: false },
	{ value: "3", label: "Grade 3", disabled: false },
	{ value: "4", label: "Grade 4", disabled: false },
	{ value: "5", label: "Grade 5", disabled: false },
	{ value: "6", label: "Grade 6", disabled: false },
	{ value: "7", label: "Grade 7", disabled: false },
	{ value: "8", label: "Grade 8", disabled: false },
	{ value: "9", label: "Grade 9", disabled: false },
	{ value: "10", label: "Grade 10", disabled: false },
	{ value: "11", label: "Grade 11", disabled: false },
	{ value: "12", label: "Grade 12", disabled: false },
];

declare const ga: (cmd: string, hitType: string, category: string, action: string, label: string) => void;
function gaEvent(label: string) {
	try { ga("send", "event", "button", "pressed", label); } catch { /* GA may not be loaded */ }
}

function gfn_IsValidEmail(str: string): boolean {
	return /^([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/.test(str);
}

const css = `
@import url('https://fonts.googleapis.com/css?family=Open+Sans');

html, body {
  -webkit-overflow-scrolling: touch;
}

body {
  margin: 0 auto;
  overflow-x: hidden;
  font-family: 'Open Sans', sans-serif;
}

.section_container {
  margin: 0 auto;
  width: 100%;
  height: auto;
}

.section_div {
  margin: 0;
  height: auto;
  width: 100%;
  display: block;
  clear: both;
  padding: 0 200px;
  overflow: visible;
  box-sizing: border-box;
}

/* ─── HEADER ─── */
#header {
  height: 40px;
  top: 0;
  width: 100%;
  z-index: 100;
  background-color: #333333;
  display: flex;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

#header .section_div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  height: 100%;
}

#main_top_container {
  width: 100%;
  position: relative;
}

#custom_logo {
  display: flex;
  align-items: center;
  padding: 0;
  min-width: 305px;
  flex-shrink: 0;
}

#custom_logo img {
  display: block;
  max-height: 30px;
  width: auto;
}

#custom_nav {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* ─── TITLE BAR ─── */
.section_title_bar {
  background-color: #178ccc;
}

.bar_section {
  padding: 0;
}

.bar_title {
  margin: 0;
  padding: 10px 0;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
}

/* ─── SECTION TITLES ─── */
.section_title {
  color: #FFF;
  text-align: center;
  padding-top: 1.5%;
  font-size: 30px;
  line-height: 35px;
}

.section_title_dark {
  color: #2A2A2A;
  padding-top: 20px;
}

.section_title_register {
  text-align: center;
  margin-top: 0;
  font-size: 20px;
  line-height: 25px;
  color: #2A2A2A;
}

/* ─── REGISTER BOXES ─── */
#register_board_container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 30px;
}

#register_box_container {
  width: 100%;
  overflow: hidden;
}

.register_img_container {
  width: 100%;
  text-align: center;
  margin-top: 15px;
}

.register_img_container img {
  max-width: 60%;
  height: auto;
}

.register_box p {
  margin-bottom: 10px;
  font-weight: normal;
}

#r1, #r2, #r3, #r4 {
  background-size: contain;       
  background-repeat: no-repeat;
  background-position: center bottom;
}

.register_box {
  width: 90%;
  margin-bottom: 20px;

  padding: 20px;
  padding-bottom: 180px;

  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: bottom center;

  background-color: #f5f5f5;
  border: 1px solid #ddd;
  box-sizing: border-box;
}


.register_box_last {
  margin-right: 0;
}

.register_box p {
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  color: #2A2A2A;
}

.register_box ul {
  margin: 10px 0 0 20px;
  padding: 0;
}

.register_box li {
  font-size: 15px;
  line-height: 26px;
  list-style: none;
  color: #2A2A2A;
}

.register_number {
  font-size: 22px;
  font-weight: bold;
  color: #178ccc;
  margin-right: 6px;
}

.list_tick {
  color: #178ccc;
  font-size: 16px;
  margin-right: 6px;
}

.red {
  color: #cc0000;
//   font-weight: bold;
}

/* ─── REGISTRATION FORM ─── */
#register_form_container {
  margin-top: 20px;
}

#register_form_container_complete {
  display: none;
  margin-top: 20px;
}

#main_registration {
  margin-top: 20px;
  overflow: hidden;
}

.main_registration_style {
  padding: 20px;
//   background-color: #fff;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

/* Input field styles */
.registration_row1 {
  width: 48%;
  height: 70px;
  padding: 0 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 15px;
  float: left;
  margin-right: 2%;
  display: block;
}

/* container */
.custom_radio {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

/* hide default radio */
.custom_radio input {
  display: none;
}

/* square box */
.radio_box {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  background: #eee;
  border-radius: 3px;
  display: inline-block;
}

/* number */
.radio_label {
  font-size: 14px;
}

/* ✅ when selected */
.custom_radio input:checked + .radio_box {
  background-color: #8bc34a;   /* green */
  border-color: #6fa83a;
}

.registration_row1.last_row {
  margin-right: 0;
}

.registration_row1_email {
  width: 68%;
  height: 70px;
  padding: 0 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 15px;
  float: left;
  margin-right: 2%;
  display: block;
}

.registration_row1_zip {
  width: 30%;
  height: 70px;
  padding: 0 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 15px;
  float: left;
  display: block;
}

.registration_row1_zip.last_row {
  margin-right: 0;
}

.registration_row3 {
  width: 100%;
  height: 70px;
  padding: 0 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 15px;
  float: left;
  display: block;
  clear: both;
}

.registration_row3.last_row {
  margin-bottom: 0;
}

.registration_row2 {
  width: 100%;
  height: 70px;
  padding: 0 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 15px;
  float: left;
  display: block;
  clear: both;
  margin-top: 50px;
}

/* Number of children */
.num_of_chld {
  clear: both;
  float: left;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
}

.num_of_chld p {
  margin: 0;
  font-size: 15px;
  font-weight: bold;
  color: #2A2A2A;
}

.num_of_chld_row2 {
  clear: both;
  float: left;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  gap: 20px;
}

#register_main_row {
  display: flex;
  gap: 20px;
  align-items: center;
}

#register_left {
  width: 40%;
}

#register_right {
  width: 60%;
}

.register_radio {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 15px;
  cursor: pointer;
}

.register_radio input[type="radio"] {
  cursor: pointer;
  accent-color: #178ccc;
  width: 16px;
  height: 16px;
}

/* Child rows */
.form_row {
  clear: both;
  overflow: hidden;
  margin-bottom: 15px;
}

.registration_child {
  width: 68%;
  height: 70px;
  padding: 0 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  float: left;
  margin-right: 2%;
  display: block;
}

.registration_grade {
  width: 30%;
  height: 70px;
  padding: 0 5px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  float: left;
  display: block;
  background-color: #fff;
}

.registration_grade.last_row {
  margin-right: 0;
}

/* Disclaimer */
.register_disclaimer_check {
  display: none;
  clear: both;
  margin-top: 20px;
  font-size: 14px;
}

/* Submit button */
.register_button {
  clear: both;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 40px;
}

.register_button button {
  background-color: #178ccc;
  color: #fff;
  border: none;
  padding: 15px 60px;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  letter-spacing: 1px;
  transition: background-color 0.2s ease;
}

.register_button button:hover {
  background-color: #1278b0;
}

.register_button button:disabled {
  background-color: #999;
  cursor: not-allowed;
}

/* Success button */
#register_complete_button {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 40px;
}

#register_complete_button button {
  background-color: #178ccc;
  color: #fff;
  border: none;
  padding: 20px 40px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

#register_complete_button button:hover {
  background-color: #1278b0;
}

.btn_sml_txt {
  font-size: 14px;
  font-weight: normal;
  display: block;
  margin-bottom: 6px;
}

/* ─── FOOTER ─── */
#main_footer {
  height: 50px;
  background-color: #333;
}

#main_footer p {
  height: 50px;
  font-size: 10px;
  color: #b3b3b3;
  line-height: 50px;
  margin: 0;
  text-align: center;
}

.footer_links {
  color: #b3b3b3;
  text-decoration: none;
}

.footer_links:hover {
  color: #fff;
  text-decoration: underline;
}

/* ─── Back to top ─── */
.back-to-top {
  display: none;
}

/* ─── Responsive ─── */
@media screen and (max-width: 740px) {
  .section_div { width: 90%; }
  .registration_row1 { width: 100%; margin-right: 0; clear: both; }
  .registration_row1_email { width: 100%; margin-right: 0; clear: both; }
  .registration_row1_zip { width: 100%; margin-right: 0; clear: both; }
  .registration_child { width: 100%; margin-right: 0; clear: both; margin-bottom: 10px; }
  .registration_grade { width: 100%; margin-right: 0; clear: both; }
  .register_box { width: 100%; margin-right: 0; }
  .num_of_chld_row2 { flex-wrap: wrap; gap: 10px; }
}

@media screen and (max-width: 550px) {
  .register_button button { padding: 12px 30px; font-size: 15px; }
}

@media (max-width: 900px) {
  #register_main_row {
    flex-direction: column;
  }

  #register_left,
  #register_right {
    width: 100%;
  }


/* ─── Fade animations ─── */
@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: both;
}
`;

interface ChildRowProps {
	index: number;
	visible: boolean;
	name: string;
	grade: string;
	onNameChange: (val: string) => void;
	onGradeChange: (val: string) => void;
}

function ChildRow({ index, visible, name, grade, onNameChange, onGradeChange }: ChildRowProps) {
	if (!visible) return null;
	return (
		<div className="form_row" id={`child${index}`}>
			<input
				type="text"
				id={`txtChild${index}`}
				className="registration_child"
				name={`child${index}`}
				placeholder={`Child ${index}`}
				maxLength={30}
				value={name}
				onChange={e => onNameChange(e.target.value)}
			/>
			<select
				id={`ddlGrade${index}`}
				className="registration_grade last_row"
				value={grade}
				onChange={e => onGradeChange(e.target.value)}
			>
				{GRADE_OPTIONS.map(opt => (
					<option key={opt.value} value={opt.value} disabled={opt.disabled}>
						{opt.label}
					</option>
				))}
			</select>
		</div>
	);
}

export default function MDFreeAssessment() {

	const [parentName, setParentName] = useState("");
	const [parentSName, setParentSName] = useState("");
	const [parentEmail, setParentEmail] = useState("");
	const [parentZip, setParentZip] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [noOfChild, setNoOfChild] = useState(1);
	const [hidNoOfChild, setHidNoOfChild] = useState("");
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const [children, setChildren] = useState<{ name: string; grade: string }[]>([
		{ name: "", grade: "" },
		{ name: "", grade: "" },
		{ name: "", grade: "" },
		{ name: "", grade: "" },
		{ name: "", grade: "" },
	]);

	const [submitClicked, setSubmitClicked] = useState(false);
	const [registrationDone, setRegistrationDone] = useState(false);
	const [submitLabel, setSubmitLabel] = useState("SUBMIT");

	const registerRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		try { gaEvent("pageview"); } catch { }
	}, []);

	useEffect(() => {
		setHidNoOfChild("");
	}, []);

	function updateChild(index: number, field: "name" | "grade", value: string) {
		setChildren(prev => {
			const next = [...prev];
			next[index] = { ...next[index], [field]: value };
			return next;
		});
	}

	function handleNoOfChildChange(val: number) {
		setNoOfChild(val);
		setHidNoOfChild(String(val));
		setChildren(prev => {
			const next = [...prev];
			for (let i = val; i < 5; i++) {
				next[i] = { name: "", grade: "" };
			}
			return next;
		});
	}

	function onZipKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
		if (e.charCode < 48 || e.charCode > 57) e.preventDefault();
	}

	async function handleSubmit(e: React.FormEvent) {
		e.preventDefault();
		if (submitClicked) {
			alert("Please wait..\nYour previous request is being processed.");
			return;
		}

		if (parentName.trim() === "") { alert("Please Enter Parent Name."); return; }
		if (parentSName.trim() === "") { alert("Please enter parent surname."); return; }
		if (parentEmail.trim() === "") { alert("Please enter a parent email."); return; }
		if (!gfn_IsValidEmail(parentEmail.trim())) { alert("Please enter a valid email."); return; }
		if (parentZip.trim() === "") { alert("Please enter zip code."); return; }
		if (isNaN(Number(parentZip.trim()))) { alert("Zipcode should not contain alphabetic characters.\nPlease enter a valid zipcode."); return; }
		if (phoneNumber.trim() === "") { alert("Please enter phone number."); return; }
		if (isNaN(Number(phoneNumber.trim())) || phoneNumber.trim().length < 10) { alert("Please enter valid phone number."); return; }

		for (let i = 0; i < noOfChild; i++) {
			if (children[i].name.trim() === "") { alert(`Please enter name of child ${i + 1}.`); return; }
			if (children[i].grade === "") { alert(`Please select grade for child ${i + 1}.`); return; }
		}

		for (let i = 0; i < noOfChild; i++) {
			for (let j = 0; j < noOfChild; j++) {
				if (i !== j && children[i].name.trim() === children[j].name.trim()) {
					alert(`Please type in a different name for student ${i + 1} and student ${j + 1}.`); return;
				}
			}
		}

		if (username.trim() === "") { alert("Please enter username."); return; }
		if (password.trim() === "") { alert("Please enter password."); return; }
		if (confirmPassword.trim() === "") { alert("Please confirm password."); return; }
		if (password.trim() !== confirmPassword.trim()) {
			alert("Passwords didn't match.");
			setPassword("");
			setConfirmPassword("");
			return;
		}

		let canUseLogin: string;
		try {
			const resp = await fetch(
				`${API_BASE_URL}api/md-free-assessment/check-username/?CanUseLogin=${encodeURIComponent(username.trim())}`,
				{ method: "GET", headers: { "X-Requested-With": "XMLHttpRequest" } }
			);
			const data = await resp.json();
			canUseLogin = data["CanUseLogin"];
		} catch {
			alert("Network error checking username. Please try again.");
			return;
		}

		if (canUseLogin === "False") {
			alert("The username is already used. Please use different username.");
			setUsername("");
			setPassword("");
			setConfirmPassword("");
			return;
		}

		setSubmitLabel("PLEASE WAIT.");
		setSubmitClicked(true);
		gaEvent("get started science mobile btn");

		try {
			const payload = {
				parentName: parentName.trim(),
				parentSName: parentSName.trim(),
				parentEmail: parentEmail.trim(),
				parentZip: parentZip.trim(),
				phoneNumber: phoneNumber.trim(),
				noOfChild: noOfChild,
				username: username.trim(),
				password: password.trim(),
				children: children.slice(0, noOfChild).map(c => ({
					name: c.name.trim(),
					grade: c.grade,
				})),
			};

			const resp = await fetch(`${API_BASE_URL}api/md-free-assessment/register/`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(payload),
			});
			const result = await resp.json();

			if (result.success) {
				setRegistrationDone(true);
				setTimeout(() => {
					registerRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
				}, 100);
			} else {
				alert(result.error || "Error in writing to DB.\nPlease Contact Our Customer Support.");
				setSubmitLabel("SUBMIT");
				setSubmitClicked(false);
			}
		} catch {
			alert("Submission failed. Please try again.");
			setSubmitLabel("SUBMIT");
			setSubmitClicked(false);
		}
	}

	function handleAddAnother() {
		window.location.href = "/MD_FreeAssessment";
	}

	return (
		<>
			<style>{css}</style>

			<a href="#" className="back-to-top">Back to Top</a>

			<div id="main_top_container">
				<div id="header">
					<div className="section_div">
						<div id="custom_nav">
							<div
								id="custom_logo"
								onClick={() => window.open("https://www.kineticeducation.com.au/")}
							>
								<img
									src={logoImg}
									alt="logo"
									style={{ height: "28px", width: "100%", objectFit: "contain", marginLeft: "50px" }}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="section_container section_title_bar">
				<span id="register" ref={registerRef} />
				<div
					id="bt_f"
					className="section_div bar_section"
					style={{
						backgroundImage: `url(${barTitleImg})`,
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center",
						backgroundSize: "contain",
						height: "80px",
						display: "flex",
						alignItems: "center",
						marginTop: "40px",
					}}
				>
					<p className="bar_title"></p>
				</div>
			</div>

			<div
				id="register_main"
				className="section_container"
				style={{
					minHeight: 800,
					backgroundColor: "#E2E2E2",
					backgroundImage: `url(${bgImage})`,
					backgroundRepeat: "repeat",
				}}
			>


				<div className="section_div">

					<div
						className="section_title section_title_dark"
						style={{ marginBottom: 40, fontWeight: "bold" }}
					>
						EXCLUSIVE TO THE FLEXISCHOOL MEMBERS
					</div>

					<div id="register_main_row">

						{/* LEFT SIDE */}
						<div id="register_left">

							<div id="register_board_container">
								<div id="register_box_container">

									<div id="r1" className="register_box" style={{ backgroundImage: `url(${r1Img})` }}>
										<p>
											<span className="register_number">&#10102;</span>
											Pinpoints exactly what your children know and do not know.
										</p>
									</div>

									<div id="r2" className="register_box" style={{ backgroundImage: `url(${r2Img})` }}>
										<p>
											<span className="register_number">&#10103;</span>
											Informs you where the identified gaps are by grade.
										</p>
									</div>

									<div id="r3" className="register_box" style={{ backgroundImage: `url(${r3Img})` }}>
										<p>
											<span className="register_number">&#10104;</span>
											Uncovers the topics that are holding your child back.
										</p>
									</div>

									<div id="r4" className="register_box" style={{ backgroundImage: `url(${r4Img})` }}>
										<p>A great tool for:</p>
										<ul>
											<li><span className="list_tick">&#10004;</span> NAPLAN preparation</li>
											<li><span className="list_tick">&#10004;</span> Scholarship exams</li>
											<li><span className="list_tick">&#10004;</span> Parents wanting to help their children do better in school.</li>
										</ul>
									</div>

								</div>
							</div>

						</div>

						{/* RIGHT SIDE */}
						<div id="register_right">

							{!registrationDone && (
								<div id="register_form_container">

									<div className="section_title_register">
										Create a free account to start the assessment. Get your child's{" "}
										<span className="red">free</span> maths report.
										<p style={{ color: "#2A2A2A", fontSize: "20px", fontWeight: "normal" }}>(Normally valued up to $95, assess the whole family, max 5 children.)
										</p>
									</div>

									<form onSubmit={handleSubmit}>
										<div id="main_registration" className="main_registration_style">

											<input
												type="text"
												className="registration_row1"
												placeholder="Parent Name"
												value={parentName}
												onChange={e => setParentName(e.target.value)}
											/>

											<input
												type="text"
												className="registration_row1 last_row"
												placeholder="Parent Surname"
												value={parentSName}
												onChange={e => setParentSName(e.target.value)}
											/>

											<input
												type="text"
												className="registration_row1_email"
												placeholder="Email"
												value={parentEmail}
												onChange={e => setParentEmail(e.target.value)}
											/>

											<input
												type="text"
												className="registration_row1_zip last_row"
												placeholder="Postcode"
												value={parentZip}
												onChange={e => setParentZip(e.target.value)}
											/>

											<input
												type="text"
												className="registration_row3"
												placeholder="Phone Number"
												value={phoneNumber}
												onChange={e => setPhoneNumber(e.target.value)}
											/>

											<div className="num_of_chld">
												<p>Number of children:</p>
											</div>

											<div className="num_of_chld_row2">
												{[1, 2, 3, 4, 5].map(n => (
													<label key={n} className="custom_radio">
														<input
															type="radio"
															checked={noOfChild === n}
															onChange={() => handleNoOfChildChange(n)}
														/>

														<span className="radio_box"></span>
														<span className="radio_label">{n}</span>
													</label>
												))}
											</div>

											{[0, 1, 2, 3, 4].map(i => (
												<ChildRow
													key={i}
													index={i + 1}
													visible={i < noOfChild}
													name={children[i].name}
													grade={children[i].grade}
													onNameChange={val => updateChild(i, "name", val)}
													onGradeChange={val => updateChild(i, "grade", val)}
												/>
											))}

											<input
												type="text"
												className="registration_row2"
												placeholder="Create Username"
												value={username}
												onChange={e => setUsername(e.target.value)}
											/>

											<input
												type="password"
												className="registration_row3"
												placeholder="Create Password"
												value={password}
												onChange={e => setPassword(e.target.value)}
											/>

											<input
												type="password"
												className="registration_row3"
												placeholder="Confirm Password"
												value={confirmPassword}
												onChange={e => setConfirmPassword(e.target.value)}
											/>

											<div className="register_disclaimer_check">
												<label>
													<input type="checkbox" />
													I agree to Terms & Privacy Policy
												</label>
											</div>

										</div>

										<div className="register_button">
											<button type="submit" disabled={submitClicked}>
												{submitLabel}
											</button>
										</div>

									</form>
								</div>
							)}

						</div>

					</div>

				</div>



				<div id="main_footer">
					<div className="section_div">
						<p style={{color:"#707070"}}>
							Copyright 2017 Kinetic Education. &nbsp;&nbsp;
							<a href="privacy.html" target="_blank" className="footer_links" style={{color:"#707070"}}>Privacy Policy</a>
							&nbsp;&nbsp;
							<a href="termsofuse.html" target="_blank" className="footer_links" style={{color:"#707070"}}>Terms of Use</a>
						</p>
					</div>
				</div>

			</div>
		</>
	);
}